import * as Sentry from '@sentry/browser'
import { kAgentV2RouterApiBasePath } from '@/constants/constants-api-paths'
import { kPaxtonAppApiRESTBaseUrl } from '@/constants/constants-links'
import { getResponseDebugContext, getTopLevelKeys } from '@/util/api/response-body'
import { ApiResponsePayloadError } from '@/util/errors/api-response-payload-error'
import { AgentV2CreateFollowUpQuestionsResponse, AgentV2CreateFollowUpQuestionsResponseSchema } from '@/agent-v2/store/schemas'
import { agentV2Request } from './agent-v2-request'

export async function postGenerateAgentV2ConversationFollowUpQuestions(conversationId: string): Promise<AgentV2CreateFollowUpQuestionsResponse> {
  const url = `${kPaxtonAppApiRESTBaseUrl()}${kAgentV2RouterApiBasePath}/conversations/${conversationId}/follow-up-questions`
  return agentV2Request({
    url,
    method: 'POST',
    sentryEndpoint: 'POST /api/v2/agent/conversations/{conversation_id}/follow-up-questions',
    parseResponse: (data, { response, sentryTags }) => {
      const parsed = AgentV2CreateFollowUpQuestionsResponseSchema.safeParse(data)
      if (parsed.success) return parsed.data

      Sentry.withScope((scope) => {
        scope.setTags(sentryTags)
        Sentry.captureException(new Error('Agent v2 follow-up questions response schema validation failed'), {
          extra: {
            ...getResponseDebugContext(response, url),
            conversationId,
            responseKeys: getTopLevelKeys(data),
            issues: parsed.error.issues,
          },
        })
      })
      throw new ApiResponsePayloadError(response.status, 'Invalid Agent v2 follow-up questions response shape', parsed.error.issues)
    },
  })
}
